import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../NewIPDPatientAdmission.module.css";

const InsurancePayment = ({ formData, handleInputChange }) => {
  const { t } = useTranslation();

  // Validation handler for Adhar Card (12 digits only)
  const handleAdharChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    if (value.length <= 12) {
      handleInputChange({ target: { name: 'adharCardNo', value } });
    }
  };

  // Validation handler for PAN Card (10 alphanumeric characters, uppercase)
  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''); // Only alphanumeric
    if (value.length <= 10) {
      handleInputChange({ target: { name: 'panCardNo', value } });
    }
  };

  return (
    <div className={styles.section}>
      <h3>{t("Payment & Insurance Details")}</h3>
      <div className={styles.grid3}>
        <div>
          <label>{t("TPA ID")}</label>
          <input type="text" name="tpaId" value={formData.tpaId} onChange={handleInputChange} placeholder={t("Enter TPA ID")} />
        </div>
        <div>
          <label>{t("TPA Validity")}</label>
          <input type="date" name="tpaValidity" value={formData.tpaValidity} onChange={handleInputChange} />
        </div>
        <div>
          <label>{t("Adhar/National ID")} <span style={{ color: '#999', fontSize: '0.85em' }}>({t("12 digits")})</span></label>
          <input
            name="adharCardNo"
            value={formData.adharCardNo}
            onChange={handleAdharChange}
            placeholder={t("Enter 12-digit Adhar No")}
            maxLength="12"
            pattern="\d{12}"
          />
        </div>
      </div>

      <div className={styles.grid3} style={{ marginTop: "1rem" }}>
        <div>
          <label>{t("PAN Card Number")} <span style={{ color: '#999', fontSize: '0.85em' }}>({t("10 characters")})</span></label>
          <input
            name="panCardNo"
            value={formData.panCardNo}
            onChange={handlePanChange}
            placeholder={t("Enter 10-character PAN")}
            maxLength="10"
            pattern="[A-Z0-9]{10}"
            style={{ textTransform: 'uppercase' }}
          />
        </div>
        <div>
          <label>{t("Insurance Card/Details")}</label>
          <input name="insuranceCardNo" value={formData.insuranceCardNo} onChange={handleInputChange} placeholder={t("Insurance Card/Details")} />
        </div>
        {/* Removed Payment Mode & Advance Payment as per request */}
      </div>
    </div>
  );
};

export default InsurancePayment;
